// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"DocumentsInput_cardTitle__2aAJ1","addBtn":"DocumentsInput_addBtn__1lVA1","closeBtn":"DocumentsInput_closeBtn__1Dmy7"};